var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.menuContent},_vm._l((_vm.items),function(item,i){
var _obj;
return _c('nuxt-link',{key:i,class:[_vm.$style.link, ( _obj = {}, _obj[_vm.$style.accent] = !!item.accent, _obj ), _vm.colorType],attrs:{"to":_vm._f("filterUrl")(item.url)}},[_vm._v("\n    "+_vm._s(item.title)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }